module.exports = " <div class=app> <router-view></router-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 328
 ** module chunks = 2
 **/